module.exports = __webpack_public_path__ + "assets/logo-foxgid-white-pro.c71cc62a.svg";